/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacFileEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_FILE_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.OfacFileEvent';
export const ixfWatchlistV1OfacFileEventEntity = new schema.Entity<IxfWatchlistV1OfacFileEvent>(IXF_WATCHLIST_V1_OFAC_FILE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1OfacFileEvent) => `${entity.metadata?.eventId}` });

